function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_531_2126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.8601 35.43C63.8601 51.1319 51.1319 63.8601 35.43 63.8601C19.7281 63.8601 7 51.1319 7 35.43C7 19.731 19.7281 7 35.43 7C51.1319 7 63.8601 19.731 63.8601 35.43Z",
  fill: "url(#paint0_linear_531_2126)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter1_f_531_2126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.6481 35.4032C53.6481 45.4011 45.5437 53.5056 35.5457 53.5056C25.5478 53.5056 17.4434 45.4011 17.4434 35.4032C17.4434 25.407 25.5478 17.3008 35.5457 17.3008C45.5437 17.3008 53.6481 25.407 53.6481 35.4032Z",
  fill: "#67EDFF"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_b_531_2126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.9997 46.5702C74.9997 62.2721 62.2716 75.0002 46.5697 75.0002C30.8678 75.0002 18.1396 62.2721 18.1396 46.5702C18.1396 30.8711 30.8678 18.1401 46.5697 18.1401C62.2716 18.1401 74.9997 30.8711 74.9997 46.5702Z",
  fill: "#67EDFF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7786 44.2901L39.329 44.066L40.3042 55.4707L37.7537 55.6948L31.6949 49.0062L32.3114 56.1571L29.761 56.3812L28.7858 44.9765L31.1629 44.7693L37.387 51.6288L36.7786 44.2901Z",
  fill: "url(#paint1_linear_531_2126)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.3617 43.1387L50.556 45.4067L44.876 45.8897L45.0688 48.2419L50.1894 47.7989L50.3653 49.9776L45.2448 50.4206L45.452 52.7977L51.3054 52.2978L51.5049 54.5462L43.1064 55.2505L42.1313 43.8458L50.3617 43.1387Z",
  fill: "url(#paint2_linear_531_2126)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M56.931 49.1833L58.3993 42.4433L61.0587 42.2062L63.6315 48.5938L65.3375 41.8331L68.1006 41.6027L65.0991 53.3558L63.1975 53.5216L60.0144 45.7885L58.2109 53.9372L56.3092 54.103L51.343 43.0218L54.1061 42.7914L56.931 49.1833Z",
  fill: "url(#paint3_linear_531_2126)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_531_2126",
  x: -6,
  y: -6,
  width: 82.8604,
  height: 82.8599,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_531_2126"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_531_2126",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_531_2126",
  x: 0.443359,
  y: 0.300781,
  width: 70.2051,
  height: 70.2046,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.5,
  result: "effect1_foregroundBlur_531_2126"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b_531_2126",
  x: -5.86035,
  y: -5.85986,
  width: 104.86,
  height: 104.86,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_531_2126"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_531_2126",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_531_2126",
  x1: 39.616,
  y1: 39.2376,
  x2: -10.3463,
  y2: 63.5304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6CCBC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#237D7D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_531_2126",
  x1: 29.176,
  y1: 50.2093,
  x2: 44.5008,
  y2: 53.3813,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.53
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_531_2126",
  x1: 42.1944,
  y1: 49.3237,
  x2: 55.2736,
  y2: 52.1062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.53
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_531_2126",
  x1: 52.4164,
  y1: 46.729,
  x2: 70.1024,
  y2: 50.2883,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.53
})));

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "assets/media/New.63ddb4bb.svg";
export { ForwardRef as ReactComponent };